import { render, staticRenderFns } from "./DSColors.vue?vue&type=template&id=31c85439&"
import script from "./DSColors.vue?vue&type=script&lang=js&"
export * from "./DSColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports